<template>
   <div>
       <Header></Header>
       <div style="padding-top:44px;">
        <div class="back">
         <mu-icon @click="goback" value="arrow_back"></mu-icon>
           </div>
       <div style="padding:5px 20px; text-align:left;font-size:1rem;">
           一键购买 CNY<!--   <strong>购买前请务必联系客服</strong> <mu-button fab  color="primary">客服</mu-button> -->
       </div>
       <div style="padding:5px 20px; text-align:left;">单价:1 ¥</div>
       <div class="hbox flex-left" v-if="false">
           <div @click="way=0">
               按金额购买
           </div>
           <div>|</div>
           <div @click="way=1">
               按数量购买
           </div>
    
       </div>
       <div>
           <div  v-if='way==0'>
               <mu-text-field type='number' placeholder='请输入购买金额'  v-model='total'></mu-text-field>
               <span>CNY</span>
           </div>
           <div v-else> 
           <mu-text-field placeholder='请输入购买数量' v-model='num'></mu-text-field>
               <span>CNY</span>
           </div>
       </div>
       
       <div>
            <div style="padding:20px;text-align:left;">选择付款方式</div>
            <div class="hbox">
                
                <div @click="selectWay('银行卡')" :class="{payway:true,selectedpay:payway=='银行卡'}" >银行卡</div>
                <div v-if="false" @click="selectWay('支付宝')" :class="{payway:true,selectedpay:payway=='支付宝'}">支付宝</div>
                <div v-if="false" @click="selectWay('微信')" :class="{payway:true,selectedpay:payway=='微信'}">微信</div>
            </div>
       </div>

       <div class="vgap">
           <div>成交单价:1 CNY</div>
           <div>成交数量:{{total}}</div>
           <div>实付金额:{{total}}</div>
       </div>

       <div style="padding:20px;"><mu-button full-width color='primary' @click="submit">购买 CNY</mu-button></div>
       </div>

   </div>
</template>

<script>
import Header from '@/components/Header'
import Api from '@/api'
export default {
 data(){
      return {
          way:0,
          payway:'银行卡',
          num:0,
          total:0,
          huilv:1
      }

 },
 components:{
     Header
 },
 methods:{
     selectWay(way){
         this.payway=way;
     },
     submit()
     { 
        if(this.total<100){
            this.$toast("交易金额不能小于100,请修改交易金额!")
            return;
        }
        Api.recharge(this.total*this.huilv,this.payway).then((res)=>{
            this.$toast("提交成功,赶快告诉客服小姐姐一声吧");
            toService();
        })
     },
     goback(){
         console.log("back");
         this.$router.go(-1);
     }
 }
}
</script>

<style>
  .payway{
      width: 25%;
      height:25vw;
      background: #eeeeee;
      
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;;
      
  }
  .check-flag {
      height: 0;
    width: 0;
    border-bottom: 24px solid #357ce1;
    border-left: 24px solid transparent;
    position: absolute;
    right: 0;
    bottom: 0;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .flex-left{
      justify-content: flex-start;
      padding:20px;
  }
  .flex-left div {
     padding:5px 8px;
  }
  .selectedpay {
     border:#357ce1 1px solid;
  }
  .vgap {
      padding:20px;
      text-align: left;
  }
  .vgap div {
     padding:5px 0px;
  }
  .back {
      padding:5px 20px;
      text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/pages/BuyCNc.vue